import { defineComponent as _defineComponent } from 'vue'


  interface Tab {
    key: string;
    text: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'tabs-controller',
  props: {
    value: null,
    tabs: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
    value: string;
    tabs: Tab[];
  };

  

  

  function selectTab(tab: Tab) {
    emit('input', tab.key);
  }
  
return { __sfc: true,props, emit, selectTab }
}

})